/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllEquipmentForOfflineQueryResponse, ListAllEquipmentForOfflinePathParams, ListAllEquipmentForOfflineQueryParams, ListAllEquipmentForOffline400, ListAllEquipmentForOffline401, ListAllEquipmentForOffline403, ListAllEquipmentForOffline404, ListAllEquipmentForOffline409, ListAllEquipmentForOffline500 } from "../../types/equipmentController/ListAllEquipmentForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllEquipmentForOffline } from "../../client/equipmentController/listAllEquipmentForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllEquipmentForOfflineQueryKey = (organizationId: ListAllEquipmentForOfflinePathParams["organizationId"] | undefined, params?: ListAllEquipmentForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/equipment/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllEquipmentForOfflineQueryKey = ReturnType<typeof listAllEquipmentForOfflineQueryKey>

export function listAllEquipmentForOfflineQueryOptions(organizationId: ListAllEquipmentForOfflinePathParams["organizationId"] | undefined, params?: ListAllEquipmentForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllEquipmentForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllEquipmentForOfflineQueryResponse, ResponseErrorConfig<ListAllEquipmentForOffline400 | ListAllEquipmentForOffline401 | ListAllEquipmentForOffline403 | ListAllEquipmentForOffline404 | ListAllEquipmentForOffline409 | ListAllEquipmentForOffline500>, ListAllEquipmentForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllEquipmentForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated fleet dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/equipment/all}
 */
export function useListAllEquipmentForOffline<TData = ListAllEquipmentForOfflineQueryResponse, TQueryData = ListAllEquipmentForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllEquipmentForOfflineQueryKey>(organizationId: ListAllEquipmentForOfflinePathParams["organizationId"] | undefined, params?: ListAllEquipmentForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllEquipmentForOfflineQueryResponse, ResponseErrorConfig<ListAllEquipmentForOffline400 | ListAllEquipmentForOffline401 | ListAllEquipmentForOffline403 | ListAllEquipmentForOffline404 | ListAllEquipmentForOffline409 | ListAllEquipmentForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllEquipmentForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllEquipmentForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllEquipmentForOffline400 | ListAllEquipmentForOffline401 | ListAllEquipmentForOffline403 | ListAllEquipmentForOffline404 | ListAllEquipmentForOffline409 | ListAllEquipmentForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}